import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import IntegrationButtonWrapperWithFeatureRequest from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-button/IntegrationButtonWrapperWithFeatureRequest";
import { API_ITEMS_CONFIGS } from "app/pages/sales-intelligence/modules/manage-integrations/constants/api-items";
import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import type { ApiPageType } from "app/pages/sales-intelligence/modules/manage-integrations/types/api-page-type";
import openExternalLink from "app/pages/sales-intelligence/modules/manage-integrations/utils/openExternalLink";
import { SI_DATA_CREDITS_API_KEYS_URL } from "app/pages/sales-intelligence/modules/management/sub-modules/constants";
import { StyledGatewayPrimaryButton } from "app/pages/sales-intelligence/pages/management/containers/GatewayPageContainer/styles";
import { isAfterTrial, isNoTouch, isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

interface IGetApiKeyButtonProps {
    apiType: ApiPageType;
    dataAutomation?: string;
    variant?: "default" | "gateway";
}

const GetApiKeyButton = ({
    apiType,
    dataAutomation = "get-api-key-button",
    variant = "default",
}: IGetApiKeyButtonProps) => {
    const { translate } = useTranslate();

    const isEnabled = !isTrial(swSettings) && !isAfterTrial(swSettings) && !isNoTouch(swSettings);

    const handleUpgradeClick = () => {
        manageIntegrationsTrackingService.trackApiUpgradeClick(apiType);
    };

    const handleLinkClick = () => {
        manageIntegrationsTrackingService.trackGatewayApiKeyClick(apiType);
        openExternalLink(SI_DATA_CREDITS_API_KEYS_URL);
    };

    return (
        <IntegrationButtonWrapperWithFeatureRequest
            hookId={API_ITEMS_CONFIGS[apiType]?.hookId}
            isEnabled={isEnabled}
            dataAutomationNameSpace="api-gateway"
            upgradeButtonText={translate("si.common.contact_us")}
            onUpgradeClick={handleUpgradeClick}
        >
            {variant === "gateway" ? (
                <StyledGatewayPrimaryButton
                    buttonHtmlType="button"
                    type="primary"
                    iconName="link-out"
                    placement="right"
                    data-automation={dataAutomation}
                    onClick={handleLinkClick}
                >
                    {translate("si.manage-integrations.gateway.common.get-api-key")}
                </StyledGatewayPrimaryButton>
            ) : (
                <IconButton
                    iconName="link-out"
                    placement="right"
                    data-automation={dataAutomation}
                    onClick={handleLinkClick}
                >
                    {translate("si.manage-integrations.gateway.common.get-api-key")}
                </IconButton>
            )}
        </IntegrationButtonWrapperWithFeatureRequest>
    );
};

export default GetApiKeyButton;
